@if (booting()) {
  <app-boot-spinner />
}
<div [attr.hidden]="booting() ? '' : null">
  <router-outlet />
</div>
